import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-credit-hold-action-dropdown',
    templateUrl: './CreditHoldActionDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => CreditHoldActionDropdownComponent) }]
})
export class CreditHoldActionDropdownComponent extends BaseDropdownComponent {


    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }


    ngOnInit(): void {
    }

    public load() {

        var filter: filters.CreditHoldActionFilter = { IncludeInactive: false };
        this.domainDataService.getCreditHoldActions(filter).subscribe(x => this.onGetRecordsDone(x));
    }

    onGetRecordsDone(items: ent.CreditHoldAction[]) {
        this.selectItems.push({ label: "", value: Constants._NONE });
        items.forEach(y => this.selectItems.push({ label: y.Name, value: y.ID }));
        if (this.selectedID) {
            this.value = this.selectedID;
        }

    }

}